import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import loaderMixin from '@/mixins/loader';
import topComment from './top-comment/top-comment.vue';

export default {
  props: {
    widget: Object,
  },
  mixins: [loaderMixin],
  components: {
    swiper: Swiper,
    swiperSlide: SwiperSlide,
    topComment,
  },
  data() {
    return {
      rightDis: false,
      leftDis: true,
      swiperInstance: null,
      swiperModules: [Autoplay],
      swiperOptions: {
        spaceBetween: 0,
        autoplay: { enabled: true, delay: 10 * 1000 },
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
      },
    };
  },
  computed: {
    obj() {
      return !this.widget ? {} : this.widget;
    },
    items() {
      return this.widget.widgetTopComments || [];
    },
    lastIndex() {
      return this.items.length;
    },
    prevArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--left': true,
      };
    },
    nextArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--right': true,
      };
    },
  },
  methods: {
    onSwiperReady(swiperInstance) {
      this.swiperInstance = swiperInstance;
    },
    onTransitionStart(swp) {
      const ax = swp.activeIndex % this.lastIndex;
      this.leftDis = ax === 1;
      this.rightDis = ax === 0;
    },
    prevSlide() {
      this.swiperInstance.slidePrev();
    },
    nextSlide() {
      this.swiperInstance.slideNext();
    },
  },
  watch: {
    widget(val) {
      if (val) {
        this.loaderRemove();
      }
    },
  },
  mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  },
};
